import React from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation} from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import ScrollToTop from "./utils/ScrollToTop";
import Page from "./pages/page";
import {CookieConsent, Cookies} from "react-cookie-consent";
import SiteMap from "./pages/siteMap";
import Homepage from "./pages/homepage";
import GoogleAnalytics from "./lib/GoogleAnalytics";

const PageTransition = ({ children }) => {
    return (
        <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ ease: 'easeInOut', duration: 0.5 }}
        >
            {children}
        </motion.div>
    );
};

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
            <AnimatePresence>
                <GoogleAnalytics id={'G-JRQ817J8CY'}/>
                <Routes location={location} key={location.pathname}>
                    <Route path="/" element={<PageTransition><Homepage /></PageTransition>} />
                    <Route path="/politique-confidentialite-donnees" element={<PageTransition><Page type={31} /></PageTransition>} />
                    <Route path="/mentions-legales" element={<PageTransition><Page type={32} /></PageTransition>} />
                    <Route path="/cgu" exact element={<PageTransition><Page type={30} /></PageTransition>} />
                    <Route path="/plan-site" exact element={<PageTransition><SiteMap /></PageTransition>} />
               </Routes>
            </AnimatePresence>
    );
};
function App() {
    const handleAccept = () => {
        console.log('Cookies acceptés');
    };
    const handleDecline = () => {
        console.log('Cookies refusés');
        Cookies.remove('myAwesomeCookieName');
    };

    return (
            <Router>
                <ScrollToTop/>
                <AnimatedRoutes />
                <CookieConsent
                        location="bottom"
                        buttonText="J'accepte"
                        declineButtonText="Je refuse"
                        cookieName="myAwesomeHotline"
                        style={{ background: "#2B373B" }}
                        buttonStyle={{ background: "#5B7052", color: "white", fontSize: "13px", borderRadius: "50px", padding: "6px 15px" }}
                        declineButtonStyle={{ background: "#AB3331", color: "white", borderRadius: "50px", padding: "6px 15px", fontSize: "13px"}}
                        expires={60}
                        onAccept={handleAccept}
                        onDecline={handleDecline}
                        enableDeclineButton
                        flipButtons={1}
                >
                    Ce site utilise des cookies pour améliorer l'expérience utilisateur.{" "}
                    <a href="/politique-confidentialite-donnees" style={{ color: "#ffffff" }}>En savoir plus</a>
                </CookieConsent>
            </Router>
    );
}

export default App;
